import React, { FC, useState } from 'react'
import axios from 'axios'
import { H2 } from 'components/base/typography/headings'
import { P } from 'components/base/typography/misc'
import UserInfoForm from './userInfoForm'
import { UserInfoFormData } from 'reducers/formReducer'
import SignupFormLoader from './signupFormLoader'
import SignupCompleted from '../signupCompleted'
import { Auth } from 'aws-amplify'
import { signupErrorMsgMapper } from './userInfoForm/signupErrorMsgMapper'
import { API_URL } from 'constants/paths/paths'
import { RichTextBlock } from 'prismic-reactjs'
// @ts-ignore
import { RichText } from 'prismic-reactjs'
import { RichTextStyleWrapper } from 'components/base/typography/richTextStyleWrapper'
import styled from 'styled-components'

export type FormState =
	| 'awaiting-user-info'
	| 'submitting-user-creation'
	| 'submitting-user-application'
	| 'signup-form-submitted'

interface Props {
	title: RichTextBlock[]
	text: RichTextBlock[]
	successTitle: RichTextBlock[]
	successText: RichTextBlock[]
}

const TextWrapper = styled(RichTextStyleWrapper as any)`
	margin-bottom: 5rem;
`

const SignupForm: FC<Props> = ({ title, text, successTitle, successText }) => {
	const [formState, setFormState] = useState<FormState>('awaiting-user-info')
	const [formError, setFormError] = useState('')
	const [userInfoData, setUserInfoData] = useState<UserInfoFormData | null>(null)

	const handleUserInfoSubmit = async (data: UserInfoFormData) => {
		data.email = data.email.toLowerCase()
		setUserInfoData(data)
		setFormState('submitting-user-creation')
		try {
			const user = await Auth.signUp({
				username: data.email,
				password: data.password,
				attributes: {
					address: 'Default address',
					name: data.name,
					phone_number: data.tel, // eslint-disable-line
				},
			})
			setFormState('submitting-user-application')
			await axios.post(`${API_URL}/applications/register`, {
				name: data.name,
				userId: user.userSub,
				email: data.email,
				phone: data.tel,
				companyRegNo: data.companySocialId,
				jobTitle: data.jobTitle,
				comments: data.comments,
				postlistSelected: data.postlistSelected,
			})
			setFormState('signup-form-submitted')
		} catch (err) {
			// @ts-ignore
			setFormError(signupErrorMsgMapper[err.message] || err.message)
			setFormState('awaiting-user-info')
		}
	}

	return (
		<div>
			{formState === 'awaiting-user-info' && (
				<>
					<H2 mt="1rem" mb="3rem">
						{RichText.asText(title || [])}
					</H2>
					<TextWrapper>{RichText.render(text || [])}</TextWrapper>
				</>
			)}
			{formState === 'submitting-user-creation' && <SignupFormLoader message="Bý til notanda" />}
			{formState === 'submitting-user-application' && <SignupFormLoader message="Sendi inn umsókn" />}
			{formState === 'awaiting-user-info' && <UserInfoForm onSubmit={handleUserInfoSubmit} formError={formError} />}
			{formState === 'signup-form-submitted' && (
				<SignupCompleted email={userInfoData?.email || ''} title={successTitle} text={successText} />
			)}
		</div>
	)
}

export default SignupForm
